<template>
    <transition name="modal-fade">
        <div class="dibble-modal">
            <div id="modalEditBanner" class="modal small-m">
                <div
                    class="modal-dialog modal-form justify-content-center text-left"
                    role="document"
                >
                    <div class="modal-content">
                        <div class="modal-header">
                            <p
                                class="title-modal"
                                v-text="'Goal Meter Widget'"
                            ></p>
                            <button
                                type="button"
                                data-dismiss="modal"
                                aria-label="Close"
                                @click="closeModal"
                            >
                                <img
                                    src="@/assets/images/close-dialog.svg"
                                    alt="close-icon"
                                />
                            </button>
                        </div>
                        <vue-custom-scrollbar class="scroll-area"
                                              style="width: 100%; overflow-x: hidden"
                                              :settings="modalScrollbarSettings">
                            <div class="modal-body mt-2">
                                <div class="row">
                                    <div class="col-6 position-relative">
                                        <div v-if="isReadOnly" class="disabled-readonly"></div>
                                        <TextField
                                            v-model="name"
                                            name="name"
                                            label="Widget Name"
                                        />
                                        <SelectField
                                            v-if="!isReadOnly"
                                            v-model="campaign"
                                            name="campaign"
                                            label="Campaign"
                                            :options="campaignsOptions"
                                            :has-icon="true"
                                            :show-tooltip="false"
                                        >
                                            <template #append-icon>
                                                <a @click.prevent="() => {}">
                                                    <i
                                                        class="fa fa-chevron-circle-down mt-2"
                                                        style="
                                                            font-size: 20px;
                                                            color: #40b8dc;
                                                        "
                                                    />
                                                </a>
                                            </template>
                                        </SelectField>
                                        <TextField
                                            v-else
                                            v-model="campaign"
                                            name="campaign_title"
                                            label="Campaign"
                                        />
                                        <DesignItem label="Background color">
                                            <ColorField
                                                name="backgroundColor"
                                                v-model="backgroundColor"
                                            />
                                        </DesignItem>
                                        <DesignItem label="Text color">
                                            <ColorField
                                                name="textColor"
                                                v-model="textColor"
                                            />
                                        </DesignItem>
                                        <DesignItem label="Progress color">
                                            <ColorField
                                                name="progressColor"
                                                v-model="progressColor"
                                            />
                                        </DesignItem>
                                        <DesignItem label="Border size">
                                            <RangeField
                                                name="borderSize"
                                                v-model="borderSize"
                                                :min-value="borderSizeMin"
                                                :max-value="borderSizeMax"
                                                :step="borderSizeStep"
                                            />
                                        </DesignItem>
                                        <DesignItem label="Border radius">
                                            <RangeField
                                                name="borderRadius"
                                                v-model="borderRadius"
                                                :min-value="borderRadiusMin"
                                                :max-value="borderRadiusMax"
                                                :step="borderRadiusStep"
                                            />
                                        </DesignItem>
                                    </div>
                                    <div class="col-6">
                                        <div class="mb-1 text-secondary">
                                            HTML Code:
                                        </div>
                                        <TextField
                                            v-model="htmlCode"
                                            name="htmlCode"
                                            readonly
                                            class-wrapper="html-code"
                                        >
                                            <template #append-icon>
                                                <a href="javascript:;" @click="() => {
                                                    copyToClipboard(htmlCode);
                                                }">
                                                    <img
                                                        src="~@/assets/images/copy.svg"
                                                    />
                                                </a>
                                            </template>
                                        </TextField>
                                        <div class="mb-1 text-secondary">
                                            Preview:
                                        </div>
                                        <div
                                            class="c-preview"
                                        >
                                            <ul class="c-skeleton">
                                                <li class="c-skeleton__item"></li>
                                                <li class="c-skeleton__item"></li>
                                                <li class="c-skeleton__item"></li>
                                                <li class="c-skeleton__item"></li>
                                                <li class="c-skeleton__item"></li>
                                            </ul>
                                            <div class="c-progress">
                                                <div class="c-currency" :style="{
                                                    color: textColor,
                                                }">
                                                    <span
                                                        class="c-currency__total"
                                                        >{{
                                                            toCurrency(this.amountProgress)
                                                        }}</span
                                                    >
                                                    of
                                                    <span
                                                        class="c-currency__goal"
                                                        >{{
                                                            toCurrency(this.goal)
                                                        }} goal</span
                                                    >
                                                </div>
                                                <div :style="{
                                                    backgroundColor: progressColor,
                                                    borderRadius: borderRadius + 'px',
                                                    borderWidth: borderSize + 'px',
                                                    borderColor: progressColor,
                                                    borderStyle: 'solid',
                                                        }">
                                                    <b-progress
                                                        show-progress
                                                        animated
                                                        :max="100"
                                                        :style="{
                                                            backgroundColor: backgroundColor,
                                                            borderRadius: borderRadius + 'px',

                                                        }"
                                                        :class="{'position-relative': progress < 50}"
                                                    >
                                                        <b-progress-bar
                                                            v-if="progress >= 50"
                                                            :value="progress"
                                                            :label="`${(
                                                                (progress / 100) *
                                                                100
                                                            ).toFixed(0)}%`"
                                                            :variant="progressColor"
                                                            :style="{
                                                                backgroundColor: progressColor,
                                                                color: percentageColor,

                                                            }"
                                                        ></b-progress-bar>
                                                        <b-progress-bar
                                                            v-else
                                                            :value="progress"
                                                            :label-html="`<span class='progress-bar-label-right'>${(
                                                                (progress / 100) *
                                                                100
                                                            ).toFixed(0)}%</span>`"
                                                            :variant="progressColor"
                                                            :style="{
                                                                backgroundColor: progressColor,
                                                                color: textColor,
                                                            }"
                                                        ></b-progress-bar>
                                                    </b-progress>
                                                </div>
                                            </div>
                                            <ul class="c-skeleton">
                                                <li class="c-skeleton__item"></li>
                                                <li class="c-skeleton__item"></li>
                                                <li class="c-skeleton__item"></li>
                                                <li class="c-skeleton__item"></li>
                                                <li class="c-skeleton__item"></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div class="d-flex justify-content-center mt-2">
                                        <button
                                            v-if="!isReadOnly"
                                            v-text="'Save'"
                                            class="btn-dialog btn-sm ok-btn"
                                            @click="save"
                                        ></button>
                                        <button
                                            v-if="isReadOnly"
                                            v-text="'Close'"
                                            class="btn-dialog btn-sm ok-btn"
                                            @click="closeModal"
                                        ></button>
                                    </div>
                                </div>
                            </div>
                        </vue-custom-scrollbar>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import TextField from '@/commons/FormElements/TextField.vue';
import SelectField from '@/commons/FormElements/SelectField.vue';
import DesignItem from '@/components/widgets/components/DesignItem.vue';
import ColorField from '@/commons/FormElements/ColorField.vue';
import RangeField from '@/commons/FormElements/RangeField.vue';
import DibbleJs from "@/dibble";
import DibbleApi from "@/api";
import vueCustomScrollbar from 'vue-custom-scrollbar'

export default {
    name: 'ModalWidgetGoalMeter',
    components: {
        TextField,
        SelectField,
        DesignItem,
        ColorField,
        RangeField,
        vueCustomScrollbar
    },
    props: {
        isReadOnly: {
            type: Boolean,
            default: false,
        },
        data: Object,
        campaignTitle: {
            type: String,
            default: () => ''
        },
        filterCampaignItems: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        const TOTAL = Math.floor(Math.random() * 150000);
        const GOAL = 150000;
        return {
            modalScrollbarSettings: {
                maxScrollbarLength: 250,
                wheelPropagation: false
            },
            defaultStyle: null,
            campaignsOptions: [],
            name: '',
            campaign: '',
            htmlCode: '',
            backgroundColor: '#fff',
            textColor: '#212830',
            progressColor: '#2797FF',
            borderSize: 0,
            borderSizeMin: 0,
            borderSizeMax: 10,
            borderSizeStep: 1,
            borderRadius: 0,
            borderRadiusMin: 0,
            borderRadiusMax: 10,
            borderRadiusStep: 1,
            goal: GOAL,
            total: TOTAL,
            amountTimer: null,
            amountProgress: 0,
            timer: null,
            progress: 0,
            amount: Math.floor((TOTAL / GOAL) * 100),
            shortcode: '<a href="#" class="giverise-public-widgets" data-widget-id="{WIDGET_ID}" data-width="{WIDTH}" data-height="{HEIGHT}" style="display: none"></a>'
        };
    },
    created() {
        this.campaignsOptions = this.filterCampaignItems.filter(item => item.value !== '')
        if (this.data)
            this.loadData();
        this.getDefaultStyle();
    },
    computed: {
        percentageColor() {
            return this.isHexColorDark(this.progressColor) ? '#fff' : '#000';
        },
    },
    methods: {
        loadData() {
            const val = this.data;
            if (val) {
                this.name = val.name;
                this.campaign = this.isReadOnly ? this.campaignTitle : val.campaign_id;
                this.backgroundColor = val.background_color;
                this.textColor = val.text_color;
                this.progressColor = val.progress_color;
                this.borderSize = val.border_size;
                this.borderRadius = val.border_radius;

                this.htmlCode = this.shortcode
                    .replace('{WIDGET_ID}', val.widget_id)
                    .replace('{WIDTH}', '366')
                    .replace('{HEIGHT}', '103');
            }
        },
        isHexColorDark(color) {
            const hex = color.replace('#', '');
            const c_r = parseInt(hex.substr(0, 2), 16);
            const c_g = parseInt(hex.substr(2, 2), 16);
            const c_b = parseInt(hex.substr(4, 2), 16);
            const brightness = (c_r * 299 + c_g * 587 + c_b * 114) / 1000;
            return brightness < 128;
        },
        toCurrency(number) {
            return `$${new Intl.NumberFormat().format(number)}`;
        },
        getDefaultStyle() {
            const data = {
                '#request': DibbleApi.api.widgetGetDefaultStyle,
                type: 3,
            };
            DibbleJs.callApiRequest(data, (response) => {
                if (DibbleApi.isResponseSuccess(response)) {
                    this.defaultStyle = response.style;
                } else {
                    DibbleJs.toastErrorMessage(response.message);
                }
            });
        },
        closeModal() {
            this.$emit('close');
        },
        save() {
            const params = {
                campaign_id: this.campaign,
                name: this.name,
                background_color: this.backgroundColor,
                text_color: this.textColor,
                progress_color: this.progressColor,
                border_size: this.borderSize,
                border_radius: this.borderRadius,
            };

            if (this.data) {
                params.widget_id = this.data.widget_id;
            }

            DibbleJs.showLoader();
            const data = {
                '#request': this.data ? DibbleApi.api.widgetUpdateGoalMeterBox : DibbleApi.api.widgetCreateGoalMeterBox,
                ...params,
            };
            DibbleJs.callApiRequest(data, (response) => {
                if (DibbleApi.isResponseSuccess(response)) {
                    this.$emit('success');
                    DibbleJs.toastSuccessMessage(this.data ? 'Widget updated successfully' : 'Widget created successfully');
                } else {
                    DibbleJs.toastErrorMessage(response.message);
                }
                DibbleJs.hideLoader();
            });
        },
        copyToClipboard(code) {
            const el = document.createElement('textarea');
            el.value = code;
            document.body.appendChild(el);
            el.select();
            document.execCommand('copy');
            document.body.removeChild(el);
            DibbleJs.toastSuccessMessage('Copied to clipboard');
        },
    },
    watch: {
        progress(val) {
            if (val >= this.amount) {
                clearInterval(this.timer);
                this.timer = null;
            }
        },
        amountProgress(val) {
            if (val >= this.total) {
                clearInterval(this.amountTimer);
                this.amountTimer = null;
            }
        },
        defaultStyle(val) {
            if (val) {
                if (this.data) {
                    this.borderSizeMin = val.border_size.min
                    this.borderSizeMax = val.border_size.max
                    this.borderSizeStep = val.border_size.step

                    this.borderRadiusMin = val.border_radius.min
                    this.borderRadiusMax = val.border_radius.max
                    this.borderRadiusStep = val.border_radius.step
                } else {
                    this.backgroundColor = val.background_color
                    this.textColor = val.text_color
                    this.progressColor = val.progress_color

                    this.borderSize = val.border_size.default
                    this.borderSizeMin = val.border_size.min
                    this.borderSizeMax = val.border_size.max
                    this.borderSizeStep = val.border_size.step

                    this.borderRadius = val.border_radius.default
                    this.borderRadiusMin = val.border_radius.min
                    this.borderRadiusMax = val.border_radius.max
                    this.borderRadiusStep = val.border_radius.step
                }
            }
        },
    },
    mounted() {
        this.amountTimer = setInterval(() => {
            this.amountProgress += 1000;
        }, 50);
        this.timer = setInterval(() => {
            this.progress += 1;
        }, 50);
    },
    beforeDestroy() {
        clearInterval(this.timer);
        clearInterval(this.amountTimer);
        this.timer = null;
        this.amountTimer = null;
    },
};
</script>

<style lang="scss" scoped>
.modal-content {
    min-width: 1000px !important;
}

.modal-content,
.modal-body {
    background: #edf5f7 !important;
    border-radius: 60px !important;
    padding: 10px 20px;
}

.modal-header {
    display: flex !important;
    justify-content: space-between !important;
    align-items: center;
    padding: 10px 0px !important;
    border-bottom: 1.5px solid #1c5169;
    margin: 0 20px !important;

    .title-modal {
        font-family: 'Open Sans';
        font-style: normal;
        font-weight: 700;
        font-size: 22px;
        line-height: 22px;
        letter-spacing: 0.01em;
        color: #1c5169;
        margin-top: 0 !important;
    }

    button {
        border: none !important;
        outline: none !important;
        background: initial;
    }
}

.btn-dialog.btn-sm {
    font-size: 14px;
    height: 40px;
}

.c-preview {
    padding: 16px;
    border-radius: 8px;
    width: 366px;
    height: 303px;
    aspect-ratio: 1;
    margin-bottom: 30px;
    background: #fff;
    display: flex;
    flex-direction: column;
    justify-content: center;

    .c-skeleton {
        list-style: none;
        margin: 0;
        padding: 0;
        display: flex;
        flex-direction: column;
        gap: 8px;

        &__item {
            background: #ddd;
            border-radius: 4px;
            height: 12px;

            &:nth-child(1) {
                width: 75%;
            }
            &:nth-child(2) {
                width: 80%;
            }
            &:nth-child(3) {
                width: 30%;
            }
            &:nth-child(4) {
                width: 100%;
            }
            &:nth-child(5) {
                width: 90%;
            }
        }
    }

    .c-progress {
        margin-block: 16px;
    }
    .c-currency {
        margin-bottom: 4px;
        text-align: center;
        &__goal {
            font-weight: 400;
            font-size: 18px;
        }
        &__total {
            font-weight: 700;
            font-size: 22px;
        }
    }
}
.scroll-area {
    position: relative;
    margin: auto;
    height: auto;
    max-height: calc(100vh - 120px);
    overflow: auto;
}
.disabled-readonly {
    position: absolute;
    top: 0;
    left: 0;
    background: #fff;
    opacity: 0.1;
    width: 100%;
    height: 100%;
    z-index: 9999;
}
</style>
<style type="text/css">
.scroll-area .ps__rail-y { display: none !important; }
.progress-bar-label-right {
    position: absolute;
    right: 100px;
}
.html-code .custom-form-control-type1 {
    padding-right: 50px !important;
}
</style>
